import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate, useParams } from "react-router-dom";
import LoadingSpinner from "../LoadingSpinner";
import "./index.css";
import axios from "../api/axios";
import { useSelector } from "react-redux";
import { add_details } from "../../state/resSlice";
import { useDispatch } from "react-redux";
import LineLoading from "../LineLoading";

const Customer = () => {
	const res = useSelector((state) => state.res.value);
	const dispatch = useDispatch();

	const [name, setName] = useState("");
	const [mobile, setMobile] = useState("");
	const [email, setEmail] = useState("");
	const navigate = useNavigate();
	const [code, setCode] = useState("+91");
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const params = useParams();

	useEffect(() => {
		if (res === null) {
			axios
				.post(
					`${
						process.env.REACT_APP_API
							? process.env.REACT_APP_API
							: "http://127.0.0.1:8000/api"
					}/hotel-details`,
					{
						res: params.rid,
					}
				)
				.then((response) => {
					dispatch(add_details(response.data));
				});
		}
	}, [params.rid, res, dispatch]);

	useEffect(() => {
		const customer = localStorage.getItem("customer");

		if (customer) {
			let c = JSON.parse(customer);
			setName(c.name);
			setCode(c.code);
			setEmail(c.email);
			setMobile(c.mobile);
		}
	}, []);

	const saveVisit = () => {
		setLoading(true);
		setError(null);
		axios
			.post(
				`${
					process.env.REACT_APP_API
						? process.env.REACT_APP_API
						: "http://127.0.0.1:8000/api"
				}/save-visit`,
				{ name, email, mobile, code, res: params.rid }
			)
			.then(() => {
				setLoading(false);
			});
	};

	const saveCustomer = () => {
		// if (
		// 	!(
		// 		name !== null &&
		// 		emailR.test(email.toLowerCase()) &&
		// 		mobileR.test(mobile)
		// 	)
		// ) {
		// 	setError("Fill all fields");
		// 	return false;
		// }
		if (name === "" || mobile === "") {
			setError("Fill all fields");
			return false;
		}
		if (mobile.length !== 10) {
			setError("Mobile number should be 10 digits");
			return false;
		}

		const mobileR = /^[0-9]{10}$/;

		if(mobileR.test(mobile) === false) {
			setError("Mobile number should be 10 digits");
			return false;
		}

		let customer = { name, mobile, email, code };
		localStorage.setItem("customer", JSON.stringify(customer));
		saveVisit();
		navigate(`/order/${params.rid}/${params.tid}`);
	};

	return (
		<>
			<Helmet>
				<title>Customer Details</title>
			</Helmet>
			{loading && <LoadingSpinner asOverlay />}
			<div className="main_c">
				<div className="box_c effect7">
					<div className="header_c">
						{res !== null ? res.name : <LineLoading />}
					</div>
					{error && <div className="alert alert-danger">{error}</div>}
					<div className="cust_form">
						<input
							type="text"
							name="invoice_name"
							value={name}
							onChange={(e) => setName(e.target.value)}
							maxLength={20}
							className="cus_input"
							placeholder="Name"
						/>
						<input
							type="text"
							name="mobile"
							value={mobile}
							maxLength={20}
							className="cus_input"
							onChange={(e) => setMobile(e.target.value)}
							placeholder="Mobile"
						/>
						{/* <input
							type="email"
							name="email"
							className="cus_input"
							value={email}
							maxLength={40}
							onChange={(e) => setEmail(e.target.value)}
							placeholder="Email"
						/> */}
					</div>
					<button onClick={saveCustomer} className="butt">
						Save
					</button>
					<p>&#169; {new Date().getFullYear()}</p>
				</div>
			</div>
		</>
	);
};

export default Customer;
